import React from 'react';
import PropTypes from 'prop-types';

import { Icon, DropdownMenuItem, Dropdown, NewButton } from '../../../../../components';

const SpaceHeaderDropdown = ({ onLeaveSpace = null, onDeleteSpace = null }) => (
  <Dropdown
    menuPlacement='bottom-end'
    menuStyle={{ width: 140 }}
    toggleComponent={
      <NewButton tertiary>
        <Icon name='ellipsis' />
      </NewButton>
    }
  >
    {() => (
      <>
        {onLeaveSpace && (
          <DropdownMenuItem onClick={onLeaveSpace} leftIcon={<Icon displaySize={20} name='exit' />}>
            Leave space
          </DropdownMenuItem>
        )}
        {onDeleteSpace && (
          <DropdownMenuItem
            onClick={onDeleteSpace}
            leftIcon={<Icon displaySize={20} name='trash' />}
          >
            Delete space
          </DropdownMenuItem>
        )}
      </>
    )}
  </Dropdown>
);

SpaceHeaderDropdown.propTypes = {
  onLeaveSpace: PropTypes.func,
  onDeleteSpace: PropTypes.func
};

export { SpaceHeaderDropdown };
